export default __webpack_public_path__ + "static/media/cosmetic1.ab484c8a.jpg";